<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <div v-if="created" class="alert alert-success" role="status">{{ created.name }} {{$t('notifications.created')}}.</div>
          <div v-if="updated" class="alert alert-success" role="status">{{ updated.name }} {{$t('notifications.updated')}}.</div>
          <div v-if="isLoading || deleteLoading" class="alert alert-info" role="status">{{$t('notifications.loading')}}...</div>
          <div v-if="error" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ error }}
          </div>
          <div v-if="deleteError" class="alert alert-danger" role="alert">
            <span class="fa fa-exclamation-triangle" aria-hidden="true" /> {{ deleteError }}
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBWarehouseList' }" class="btn btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
<!--          <button class="btn btn-danger" @click="del">{{ $t('buttons.delete') }}</button>-->
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row>
                <b-col>
                  <EXSBWarehouseForm
                          v-if="item"
                          :handle-submit="onSendForm"
                          :handle-update-field="updateField"
                          :values="item"
                          :errors="violations"
                          :initial-values="retrieved" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBWarehouseForm from './Form.vue'
import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXSBWarehouseForm
  },

  data () {
    return {
      item: {}
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBWarehouseUpdate')
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbwarehouse/update/isLoading',
      error: 'exsbwarehouse/update/error',
      deleteError: 'exsbwarehouse/del/error',
      deleteLoading: 'exsbwarehouse/del/isLoading',
      created: 'exsbwarehouse/create/created',
      deleted: 'exsbwarehouse/del/deleted',
      retrieved: 'exsbwarehouse/update/retrieved',
      updated: 'exsbwarehouse/update/updated',
      violations: 'exsbwarehouse/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBWarehouseList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbwarehouse/create/reset',
      deleteItem: 'exsbwarehouse/del/del',
      delReset: 'exsbwarehouse/del/reset',
      retrieve: 'exsbwarehouse/update/retrieve',
      updateReset: 'exsbwarehouse/update/reset',
      update: 'exsbwarehouse/update/update',
      updateRetrieved: 'exsbwarehouse/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbwarehouse ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
